import type { CheckboxSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outlineStyles } from 'components/Editor/styled/Outline'
import { border } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

const CheckboxStyled = styled.label<{
  $styles: ElementStyleCss<CheckboxSchemaType>
  $disabled?: boolean
}>`
  position: relative;
  display: flex;
  max-width: 100%;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  overflow: hidden;

  input {
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
    cursor: pointer;
    opacity: 0;
  }
  box-shadow: ${({ $styles }) => $styles?.effects?.boxShadow};
  padding: ${({ $styles }) => $styles.indents.padding};
  ${({ $styles }) => border($styles.item)}
  background-color: ${({ $disabled, $styles }) =>
    $disabled ? $styles.itemDisable.backgroundColor : $styles?.item?.backgroundColor};

  &:hover {
    background-color: ${({ $styles, $disabled }) =>
      !$disabled && $styles.itemHover.backgroundColor};
  }

  &:has(input:focus-visible) {
    ${outlineStyles}

    background-color: ${({ $styles, $disabled }) =>
      !$disabled && $styles.itemHover.backgroundColor};
  }
`

export default CheckboxStyled
